import { IIndexable } from 'core-ts-types';
import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APProgramSlot } from '../../../../global/builders/ap_program_slot_builder';
import { IFeedbackSuggestedPlanModel } from '../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';

export class APMarkAsMetStatus implements IIndexable {
  id: key;
  nk: string;
  program_slot: APProgramSlot['id'];
  status: 'MET';
  suggested_plan: IFeedbackSuggestedPlanModel['id'];

  constructor(markAsMetStatus: Partial<APMarkAsMetStatus>) {
    _4.merge(this, {}, markAsMetStatus);
    return this;
  }

  static build(markAsMetStatus: Partial<APMarkAsMetStatus>) {
    return new APMarkAsMetStatus(markAsMetStatus);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/builders/mark_as_met_status_builder.ts